import React from 'react';
import { useSelector } from 'react-redux';
import { InitPaymentInstructionModal } from '@/components/InitPaymentInstructionModal/InitPaymentInstructionModal';
import { closeCreateInstructionModal } from '@/reduxStore/slices/ordersSlice';
import { RootState, useAppDispatch } from '@/reduxStore/rootReducer';
import InboundPaymentDetailsBladeModal from '@/components/InboundPaymentDetailsBladeModal/InboundPaymentDetailsBladeModal';
import ApiKeyGenerateModal from '@/components/ApiKeyGenerateModal/ApiKeyGenerateModal';
import WebhookEditModal from '../WebhookEditModal/WebhookEditModal';
import SimulateTransactionModal from '@/components/SimulateTransactionModal/SimulateTransactionModal';
import IbanDetailsBladeModal from '@/components/IbanDetailsBladeModal/IbanDetailsBladeModal';
import TransactionDetailModal from '@/components/TransactionDetailModal/TransactionDetailModal';
import ExportModal from '@/components/ExportModal/ExportModal';
import IbanClientDetailsBladeModal from '@/components/IbanClientDetailsBladeModal/IbanClientDetailsBladeModal';
import CreateIbanModal from '@/components/CreateIbanModal/CreateIbanModal';
import SelectClientModal from '@/components/SelectClientModal/SelectClientModal';

export const GlobalModals = () => {
    const dispatch = useAppDispatch();
    const isOpenCreatePaymentInstructionModal = useSelector(
        (state: RootState) => state.orders.isOpenCreatePaymentInstructionModal,
    );
    const isOpenInboundPaymentDetailsBladeModal = useSelector(
        (state: RootState) => state.orders.isOpenInboundPaymentDetailsBladeModal,
    );
    const isOpenSimulateTransactionModal = useSelector(
        (state: RootState) => state.orders.isSimulateTransactionModalOpen,
    );
    const isOpenGenerateApiKeyModal = useSelector(
        (state: RootState) => state.webhookAndApiKeys.isOpenGenerateApiKeyModal,
    );
    const isOpenWebhookCreateModal = useSelector(
        (state: RootState) => state.webhookAndApiKeys.isOpenWebhookCreateModal,
    );
    const isOpenWebhookEditModal = useSelector(
        (state: RootState) => state.webhookAndApiKeys.isOpenWebhookEditModal,
    );
    const isOpenTransactionDetailModal = useSelector(
        (state: RootState) => state.transaction.isOpenTransactionDetailModal,
    );
    const isOpenIbanDetailsModal = useSelector(
        (state: RootState) => state.ibans.isOpenIbanDetailsModal,
    );

    const isOpenExportModal = useSelector((state: RootState) => state.export.isExportModalOpen);

    const isOpenIbanClientDetailsModal = useSelector(
        (state: RootState) => state.ibans.isOpenIbanClientDetailsModal,
    );

    const isOpenCreateIbanClientModal = useSelector(
        (state: RootState) => state.ibans.isOpenCreateIbanClientModal,
    );

    const isOpenSelectClientModal = useSelector(
        (state: RootState) => state.roles.isOpenSelectClientModal,
    );

    return (
        <div>
            {isOpenCreatePaymentInstructionModal && (
                <InitPaymentInstructionModal
                    isOpen={isOpenCreatePaymentInstructionModal}
                    handleCancel={() => dispatch(closeCreateInstructionModal())}
                />
            )}
            {isOpenInboundPaymentDetailsBladeModal && (
                <InboundPaymentDetailsBladeModal isOpen={isOpenInboundPaymentDetailsBladeModal} />
            )}
            {isOpenGenerateApiKeyModal && (
                <ApiKeyGenerateModal isOpen={isOpenGenerateApiKeyModal} />
            )}
            {isOpenSimulateTransactionModal && (
                <SimulateTransactionModal isOpen={isOpenSimulateTransactionModal} />
            )}
            {isOpenWebhookCreateModal && (
                <WebhookEditModal isOpen={isOpenWebhookCreateModal} isEditModal={false} />
            )}
            {isOpenWebhookEditModal && (
                <WebhookEditModal isOpen={isOpenWebhookEditModal} isEditModal={true} />
            )}
            {isOpenTransactionDetailModal && (
                <TransactionDetailModal isOpen={isOpenTransactionDetailModal} />
            )}
            {isOpenIbanDetailsModal && <IbanDetailsBladeModal isOpen={isOpenIbanDetailsModal} />}
            {isOpenExportModal && <ExportModal isOpen={isOpenExportModal} />}
            {isOpenIbanClientDetailsModal && (
                <IbanClientDetailsBladeModal isOpen={isOpenIbanClientDetailsModal} />
            )}
            {isOpenCreateIbanClientModal && (
                <CreateIbanModal isOpen={isOpenCreateIbanClientModal} />
            )}
            {isOpenSelectClientModal && <SelectClientModal isOpen={isOpenSelectClientModal} />}
        </div>
    );
};
